import { CustomizationsModel } from '@w3lcome/types';

import RequestCreator from './BaseRequest';

class Customization extends RequestCreator<CustomizationsModel> {}

const api = new Customization('/ipad/customizations');
export default api;
